/**
 * How long a consumer may hold a decision waiting for LaunchDarkly to evaluate
 * for the signed-in user before the context gives up and reports the wait as
 * settled anyway.
 *
 * A deadline is required, not defensive: the browser SDK sets no timeout on its
 * XHR, so a black-holed request never resolves or rejects and nothing would
 * release a route gated on identification. Failing open leaves the anonymous
 * evaluation in place — a wrong redirect the user can navigate out of, rather
 * than a screen that never finishes loading.
 *
 * It follows `main.tsx`'s `LD_INIT_TIMEOUT_SECONDS` rather than mirroring it:
 * the two budgets compose, so a client that never reaches LaunchDarkly spends
 * that bootstrap budget before React mounts and this one afterwards. Raising
 * either lengthens the same worst case.
 */
export const IDENTIFICATION_TIMEOUT_MS = 5000;

/**
 * Joins the parts of an evaluation context's identity. Any character that
 * cannot appear in a user id, region or crop season key works — it only has to
 * keep two different contexts from composing the same string.
 */
export const CONTEXT_KEY_SEPARATOR = '|';
